import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { toast } from "react-hot-toast";
import SelectComponent from "../../../components/Tenant/SelectComponent/SelectComponent";
import { getVendorName } from "../../../utils/getVendorName";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { hasPermission } from "../../../utils/hasPermission";
import { useUpdateFaqsMutation, useFetchfaqsByIdMutation } from "../../../features/tenant/faqs/faqs.api";
import InputComponent from "../../../components/Tenant/InputComponent/InputComponent";

const UpdateFaq = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const appUserTypes = JSON.parse(sessionStorage.getItem("appUserType")) || [];
  const userTypeOptions = [
    { id: "", name: "All Users" },
    ...appUserTypes.map((u) => ({
      id: u.user_type,
      name: u.user_type,
    })),
  ];

  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [selectedUserType, setSelectedUserType] = useState(userTypeOptions[0]);
  const [selectedLanguage, setSelectedLanguage] = useState("english");
  const [isInitialized, setIsInitialized] = useState(false);

  const [
    fetchFaq,
    { data: faqData, isLoading: isFaqLoading }
  ] = useFetchfaqsByIdMutation();

  const [
    updateFaq,
    {
      data: updateFaqData,
      isLoading: updateFaqIsLoading,
      isError: updateFaqIsError,
      error: updateFaqError,
    },
  ] = useUpdateFaqsMutation();

  const language = JSON.parse(sessionStorage.getItem("vendorData"))?.language;
  const token = sessionStorage.getItem("access_token");
  const tenant_id = JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_id;

  // Initial load
  useEffect(() => {
    const hasViewPermission = hasPermission("video");
    if (!hasViewPermission) {
      navigate(`/genefied/${getVendorName()}/`);
      return;
    }

    if (location.state?.faq) {
      const faq = location.state.faq;
      setQuestion(faq.question || "");
      setAnswer(Array.isArray(faq.answer) ? faq.answer[0] || "" : faq.answer || "");
      setSelectedLanguage(faq.language ? faq.language.toLowerCase() : "english");
      
      const foundType = userTypeOptions.find(o => o.id.toLowerCase() === (faq.type || "").toLowerCase());
      if (foundType) {
        setSelectedUserType(foundType);
      } else if (faq.type) {
        setSelectedUserType({ id: faq.type, name: faq.type });
      }
      setIsInitialized(true);
    } else if (id) {
      fetchFaq({
        token,
        tenant_id,
        id,
      });
    }
  }, [id, location.state]);

  // Load from API if state is missing
  useEffect(() => {
    if (faqData && faqData.body && !isInitialized) {
      // API might return array or single object depending on response structure
      const faq = Array.isArray(faqData.body) ? faqData.body[0] : faqData.body;
      if (faq) {
        setQuestion(faq.question || "");
        setAnswer(Array.isArray(faq.answer) ? faq.answer[0] || "" : faq.answer || "");
        setSelectedLanguage(faq.language ? faq.language.toLowerCase() : "english");
        
        const foundType = userTypeOptions.find(o => o.id.toLowerCase() === (faq.type || "").toLowerCase());
        if (foundType) {
          setSelectedUserType(foundType);
        } else if (faq.type) {
          setSelectedUserType({ id: faq.type, name: faq.type });
        }
        setIsInitialized(true);
      }
    }
  }, [faqData, isInitialized]);

  useEffect(() => {
    if (updateFaqData) {
      toast.success("Updated Successfully!");
      navigate(`/genefied/${getVendorName()}/faqs`);
    }
  }, [updateFaqData, updateFaqError]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!question) {
      toast.error("Please provide a Question", {
        id: "questionError",
      });
      return;
    }

    if (!answer) {
      toast.error("Please provide an Answer", {
        id: "answerError",
      });
      return;
    }

    updateFaq({
      token,
      tenant_id,
      id,
      body: {
        question,
        answer,
        type: selectedUserType?.id || "",
        language: selectedLanguage,
      },
    });
  };

  if (isFaqLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-lg font-semibold text-gray-600">Loading FAQ Details...</div>
      </div>
    );
  }

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Edit Faq
            <LinksComponent />
          </div>
          <div className="p-3">
            <div className="p-3 w-full bg-white shadow rounded-lg">
              <div className="w-full">
                <div className="mb-3 w-full justify-center ">
                  <div className="w-full">
                    <InputComponent
                      name={"Question"}
                      type={"textarea"}
                      value={question}
                      setValue={setQuestion}
                      required={true}
                      placeholder={"Enter Question"}
                    />
                  </div>
                </div>

                <div className="mb-3 w-full justify-center ">
                  <div className="w-full">
                    <InputComponent
                      name={"Answer"}
                      type={"textarea"}
                      value={answer}
                      setValue={setAnswer}
                      required={true}
                      placeholder={"Enter Answer"}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-4 gap-4 cmxform mt-3" id="signupForm">
                  {language && language.length && (
                    <div className=" frmds">
                      <div className=" mt-3">
                        <label htmlFor="language">Language </label>
                        <select
                          id="language"
                          type="text"
                          className="border capitalize"
                          placeholder="Add new Language"
                          value={selectedLanguage}
                          onChange={(e) =>
                            setSelectedLanguage(e.target.value.toLowerCase())
                          }
                        >
                          {language.map((x, index) => {
                            return (
                              <option key={index} value={x.split("-")[0].toLowerCase()}>
                                {x.split("-")[0]}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  )}
                  <div className="mb-6 dropds mt-3 col-span-1">
                    <SelectComponent
                      title={"User Type"}
                      placeholder={"Select user type..."}
                      selected={selectedUserType}
                      setSelected={setSelectedUserType}
                      dataArr={userTypeOptions}
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-center mt-4">
                <button
                  type="submit"
                  disabled={updateFaqIsLoading}
                  onClick={(e) => handleSubmit(e)}
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center disabled:opacity-50"
                >
                  {updateFaqIsLoading ? "Updating..." : "Update"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateFaq;
